import { Skeleton } from '@/components/ui/skeleton';

// Full-pane skeleton shown while a lazy route chunk loads. Mirrors the PageHeader + card layout the
// surfaces render, so the swap to real content doesn't jump.
export function PageFallback() {
    return (
        <div className="flex h-full w-full flex-col bg-background" aria-busy="true">
            <div className="mx-auto flex w-full max-w-6xl flex-col gap-6 px-4 py-6 sm:px-6 md:px-8 md:py-8">
                <div className="flex items-start justify-between gap-4">
                    <div className="flex items-start gap-3.5">
                        <Skeleton className="size-11 rounded-xl" />
                        <div className="space-y-2 pt-0.5">
                            <Skeleton className="h-6 w-48" />
                            <Skeleton className="h-4 w-72 max-w-[60vw]" />
                        </div>
                    </div>
                    <Skeleton className="hidden h-9 w-32 sm:block" />
                </div>
                <div className="grid gap-4 md:grid-cols-2 xl:grid-cols-3">
                    {Array.from({ length: 6 }).map((_, i) => (
                        <Skeleton key={i} className="h-36 w-full rounded-xl" />
                    ))}
                </div>
            </div>
        </div>
    );
}
